var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGradeSortDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "30px",
    viewBox: "0 0 31 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Notifications",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "[1.2]-Stations-List-View---Showing-stations-list-view-in-standard-state-Copy-4",
    transform: "translate(-899.000000, -343.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(130.000000, 130.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grade-2",
    transform: "translate(630.000000, 193.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(154.500000, 35.000000) scale(1, -1) translate(-154.500000, -35.000000) translate(139.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Outline",
    stroke: "#FFFFFF",
    x: 0.5,
    y: 0.5,
    width: 30,
    height: 29,
    rx: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9053672,18.5 L15.5131154,14.2386214 L16.4311945,15.1198609 L20.0734463,18.4554538 L21.5,17.0861431 C19.3864003,15.0573554 17.4854722,13.3932124 15.5131154,11.5 C14.0472155,12.9061097 9.5,17.110353 9.5,17.110353 L10.9053672,18.5 Z",
    id: "Arrow-Down",
    fill: "#FFFFFF"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradeSortDown);
export default __webpack_public_path__ + "static/media/grade-sort-down.87c4f26e.svg";
export { ForwardRef as ReactComponent };